import { Datagrid, FunctionField, List, TextField, TextInput } from "react-admin";

const filters = [<TextInput key="name" source="name" label="Name" alwaysOn resettable />];

export default function MiqaatVenueList() {
  return (
    <List filters={filters} sort={{ field: "name", order: "ASC" }} perPage={50}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="name" label="Name" />
        <FunctionField
          label="Coords"
          sortable={false}
          render={(record: { latitude?: number | null; longitude?: number | null }) => {
            if (record?.latitude == null || record?.longitude == null) {
              return "—";
            }
            return `${record.latitude}, ${record.longitude}`;
          }}
        />
        <TextField source="radiusMeters" label="Radius (m)" />
      </Datagrid>
    </List>
  );
}
